<template>
  <div class="jgh-detail-container">
    <SubHeader :activeId="activeId" :subList="navList" :personalObject="personal" @changeNav="changeNav" />
    <div class="jgh-content">
      <div class="content">
        <components :is="isShow"></components>
        <!-- <router-view></router-view> -->
      </div>
      <div class="jgh-side">
        <BestArticle
          class="blog-container"
          title="近期最佳文章"
          :contentList="blogList"
        ></BestArticle>
      </div>
    </div>
    <!-- <footer class="footer">
      <p>
        互联网出版许可证：新出网证（京）字277号 | 京ICP备13001908号 |
        ICP：京ICP证
      </p>
      <p>140746号 © 2021 中文集团数字出版传媒股份有限公司</p>
    </footer> -->
  </div>
</template>

<script>
import SubHeader from "@/components/pager/SubHeader.vue";
import BestArticle from "@/components/pager/BestArticle.vue";
// import Main from "./view/Main.vue";
import Blog from "./view/Blog.vue";
// import JghVideo from "./view/JghVideo.vue";
import JghMonograph from "./view/JghMonograph.vue";
import Paper from "./view/Paper.vue";
import Meeting from "./view/Meeting.vue";
// import Hybg from "./view/Hybg.vue";
import Course from "./view/Course.vue";

export default {
  components: {
    SubHeader,
    BestArticle,
  },
  data() {
    return {
      isShow: Blog,
      activeId: 1,
      navList: [
        // {
        //   title: "主页",
        //   name: Main,
        //   id: 0
        // },
        {
          title: "资讯",
          name: Blog,
          id: 1
        },
        // {
        //   title: "视频",
        //   name: JghVideo,
        //   id: 2
        // },
        {
          title: "论文",
          name: Paper,
          id: 3
        },
        {
          title: "专著",
          name: JghMonograph,
          id: 4
        },
        // {
        //   title: "行业报告",
        //   name: "Hybg",
        //   id: 5
        // },
        {
          title: "会议",
          name: Meeting,
          id: 6
        },
        {
          title: "课程",
          name: Course,
          id: 7
        },
      ],
      personal: {},
      blogList: [],
    };
  },
  created() {
    this.getReadRankingList({
      id: this.$route.query.id,
      pageNo: 1,
      pageSize: 5,
      userType: 2,
    }); //近期最佳文章
    this.detailList({
      orgId: this.$route.query.id,
    });
  },
  methods: {
    changeNav(name,id) {
      this.activeId = id
      this.isShow = name
    },
    async getReadRankingList(data) {
      const resp = await this.$apis.hundredServe.getReadRankingList(data);
      this.blogList = resp.data.list;
    },
    async detailList(data) {
      const resp = await this.$apis.hundredServe.nfdetail(data);
      document.title = resp.orgInfo.name + ' - 中文知识网'
      this.personal = resp.orgInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
.jgh-content {
  display: flex;
  margin-top: 255px;
  .content {
    width: 886px;
    background-color: #fff;
    margin-bottom: 16px;
    margin-right: 9px;
    min-height: 500px;
  }
}
.jgh-side {
  width: 295px;
  .blog-container {
    background-color: #fff;
  }
}
.footer {
  margin-top: 30px;
  text-align: center;
  color: #ccc;
}
</style>
